import { Dispatch } from 'redux';
import { IApplicationState } from '../reducers';
import actionTypes from '../actions/actionTypes';
import { PROJECT_EDIT_STATUS, SvcEventData } from '@nexxt/common/types';

import http from '../utils/http';
import config from '../config';

export function setEditedStatus(
    editType: string,
    editStatus?: PROJECT_EDIT_STATUS
) {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        await dispatch({
            type: actionTypes.SET_EDITED_STATUS,
            payload: { editType, editStatus }
        });
    };
}

export function clearEditedStatus(
    status: PROJECT_EDIT_STATUS = PROJECT_EDIT_STATUS.COMPLETED
) {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        await dispatch({
            type: actionTypes.CLEAR_EDITED_STATUS,
            payload: { status }
        });
    };
}

export const sendEvent = async (data: SvcEventData): Promise<void> => {
    try {
        const SERVICE_URL = `${config.host.data}/event/publish-event`;
        const body = {
            data
        };

        await http.post(SERVICE_URL, body);
    } catch (err) {
        console.log('Error with sending service: ', err);
    }
};
